<button mat-icon-button mat-dialog-close class="close-btn">
  <mat-icon>close</mat-icon>
</button>
<ul>
  @for (item of menu; track item.title) {
  <li (click)="goTo(item)">{{item.title}}</li>
  }
</ul>
<lotta-footer [theme]="'dark'"></lotta-footer>